export enum CalculationType {
    None = -1,
    StandardFlange = 0,
    CustomFlange = 1,
    Clamp = 2,
    EngineeredJoint = 3,
    OverriddenFlange = 4,
}
